import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './assets/tailwind.css'
import './components/ui/globalComponent.js'
import VueSweetalert2 from 'vue-sweetalert2'
import GAuth from 'vue-google-oauth2'
import 'sweetalert2/dist/sweetalert2.min.css'
import VueApexCharts from 'vue-apexcharts'

import VueClipboard from 'vue-clipboard2'
import dayjs from 'dayjs'
import 'dayjs/plugin/customParseFormat'
import 'dayjs/plugin/utc' // Import the utc plugin for Day.js
import 'dayjs/plugin/timezone' // Import the duration plugin for Day.js

import QrcodeVue from 'qrcode.vue'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'
import VueHtml2pdf from 'vue-html2pdf'
import Spinner from 'vue-simple-spinner'
import setupInterceptors from './services/setupInterceptors.js'
import VueSocialSharing from 'vue-social-sharing'
import VueTour from 'vue-tour'
import {
  STATUS,
  ALL_CURRENCY,
  TRANSACTION_TYPE,
  TENANTS,
  COUNTRY_SHORTNAMES
} from './utils/constants'
import { InputAlphaOnly } from './utils/customDirectives.js'
import global from './mixins/global'
import 'vue-tour/dist/vue-tour.css'
import { appendMetaTags } from '@/utils/helpers'
import CopyAll from '@/components/v2/common/CopyAll.vue'

// global components
Vue.component('apexchart', VueApexCharts)
Vue.component('vuehtml2pdf', VueHtml2pdf)
Vue.component('spinner', Spinner)
Vue.component('copy-all', CopyAll)
// day js
dayjs.extend(require('dayjs/plugin/customParseFormat'))
dayjs.extend(require('dayjs/plugin/utc'))
dayjs.extend(require('dayjs/plugin/timezone'))
Vue.prototype.$dayjs = dayjs
// global mixin
Vue.mixin(global)
setupInterceptors()

const gauthOption = {
  clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
  scope: 'profile email',
  prompt: 'select_account'
}
Vue.use(GAuth, gauthOption)
Vue.use(VueTour)
Vue.use(VueApexCharts)
Vue.use(VueClipboard)
Vue.use(QrcodeVue)
Vue.use(VueHtml2pdf)
Vue.prototype.$primaryColor = process.env.VUE_APP_TENANT_PRIMARY_COLOR
Vue.prototype.$secondaryColor = process.env.VUE_APP_TENANT_SECONDARY_COLOR
Vue.prototype.$STATUS = STATUS
Vue.prototype.$CURRENCY = ALL_CURRENCY
Vue.prototype.$COUNTRY = COUNTRY_SHORTNAMES
Vue.prototype.$transactionType = TRANSACTION_TYPE
Vue.prototype.$tenants = TENANTS
var filter = function (text, length, clamp) {
  clamp = clamp || '...'
  var node = document.createElement('div')
  node.innerHTML = text
  var content = node.textContent
  return content.length > length ? content.slice(0, length) + clamp : content
}
Vue.filter('truncate', filter)

const options = {
  confirmButtonColor: process.env.VUE_APP_TENANT_PRIMARY_COLOR,
  cancelButtonColor: process.env.VUE_APP_TENANT_PRIMARY_COLOR
}
const isOnDevEnvironment = process.env.NODE_ENV === 'development'
const isLocalhost = window.location.href.includes('localhost')
// we only want to initialize sentry to work on dev environment
if (isOnDevEnvironment) {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        // TODO :To update when we migrate to Production and other environnments
        tracingOrigins: [process.env.VUE_APP_URL, /^\//]
      })
    ],
    tracesSampleRate: 0.1, //  only 10% of error events will be sent to sentry to avoid depletion
    beforeSend: (event, hint) => {
      // Filter out errors from localhost. We don't want to send errors from localhost.
      if (isLocalhost) {
        return null
      }
      return event
    }
  })
}
const user = store.state.auth.user
if (user.firstName) {
  Sentry.setUser({
    id: String(user.id),
    username: `${user.firstName} ${user.lastName}`,
    email: user.email
  })
}
Vue.use(VueSocialSharing)
Vue.use(VueSweetalert2, options)
Vue.directive('alpha-only', InputAlphaOnly)

Vue.config.productionTip = false

document.addEventListener('DOMContentLoaded', (event) => {
  appendMetaTags()
})
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
